import { useFormContext } from 'react-hook-form';
import { boPhanSearchColumns, taiKhoanSearchColumns, warehouseSearchColumns } from '@/constants/search-columns';
import { FormField, SearchField } from '@/components/custom/erp';
import { AccountModel, BoPhan, KhoHang } from '@/types/schemas';
import QUERY_KEYS from '@/constants/query-keys';
import { Label } from '@/components/ui/label';
import { FormMode } from '@/types/form';
import { FormValues } from '../schemas';

function BasicInfo({ mode }: { mode: FormMode }) {
  const { setValue, watch } = useFormContext<FormValues>();
  const values = watch();

  const isViewMode = mode === 'view';

  const handleWarehouseSelection = (row: KhoHang) => {
    setValue('ma_kho', row.uuid);
    setValue('ma_kho_data', row);
  };

  const handleDepartmentSelection = (row: BoPhan) => {
    setValue('ma_bp', row.uuid);
    setValue('ma_bp_data', row);
  };

  const handleReceivableAccountSelection = (row: AccountModel) => {
    setValue('tk_cn', row.uuid);
    setValue('tk_cn_data', row);
  };

  const handlePayableAccountSelection = (row: AccountModel) => {
    setValue('tk_cn2', row.uuid);
    setValue('tk_cn2_data', row);
  };

  const handleCashAccountSelection = (row: AccountModel) => {
    setValue('tk_tm', row.uuid);
    setValue('tk_tm_data', row);
  };

  return (
    <div className='space-y-3 p-6'>
      {/* Mã cửa hàng */}
      <div className='flex flex-col sm:flex-row sm:items-center'>
        <Label className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>Mã cửa hàng</Label>
        <FormField type='text' name='ma_cuahang' className='w-80' disabled={isViewMode} />
      </div>

      {/* Mã kho */}
      <div className='flex flex-col sm:flex-row sm:items-center'>
        <Label className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>Mã kho</Label>
        <SearchField<KhoHang>
          type='text'
          displayRelatedField='ten_kho'
          columnDisplay='ma_kho'
          className='w-100'
          searchEndpoint={`/${QUERY_KEYS.KHO_HANG}/`}
          searchColumns={warehouseSearchColumns}
          dialogTitle='Danh mục kho'
          value={values.ma_kho_data?.ma_kho || ''}
          onRowSelection={handleWarehouseSelection}
          disabled={isViewMode}
        />
      </div>

      {/* Mã bộ phận */}
      <div className='flex flex-col sm:flex-row sm:items-center'>
        <Label className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>Mã bộ phận</Label>
        <SearchField<BoPhan>
          type='text'
          displayRelatedField='ten_bp'
          columnDisplay='ma_bp'
          searchEndpoint={`/${QUERY_KEYS.BO_PHAN}/`}
          searchColumns={boPhanSearchColumns}
          dialogTitle='Danh mục bộ phận'
          value={values.ma_bp_data?.ma_bp || ''}
          onRowSelection={handleDepartmentSelection}
          disabled={isViewMode}
          className='w-100'
        />
      </div>

      {/* Tk công nợ phải thu */}
      <div className='flex flex-col sm:flex-row sm:items-center'>
        <Label className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>Tk công nợ phải thu</Label>
        <SearchField<AccountModel>
          type='text'
          displayRelatedField='name'
          columnDisplay='code'
          searchEndpoint={`/${QUERY_KEYS.TAI_KHOAN}/`}
          searchColumns={taiKhoanSearchColumns}
          dialogTitle='Danh mục tài khoản'
          value={values.tk_cn_data?.code || ''}
          onRowSelection={handleReceivableAccountSelection}
          disabled={isViewMode}
          className='w-100'
        />
      </div>

      {/* Tk công nợ phải trả */}
      <div className='flex flex-col sm:flex-row sm:items-center'>
        <Label className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>Tk công nợ phải trả</Label>
        <SearchField<AccountModel>
          type='text'
          displayRelatedField='name'
          columnDisplay='code'
          searchEndpoint={`/${QUERY_KEYS.TAI_KHOAN}/`}
          searchColumns={taiKhoanSearchColumns}
          dialogTitle='Danh mục tài khoản'
          value={values.tk_cn2_data?.code || ''}
          onRowSelection={handlePayableAccountSelection}
          disabled={isViewMode}
          className='w-100'
        />
      </div>

      {/* Tk tiền mặt */}
      <div className='flex flex-col sm:flex-row sm:items-center'>
        <Label className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>Tk tiền mặt</Label>
        <SearchField<AccountModel>
          type='text'
          displayRelatedField='name'
          columnDisplay='code'
          searchEndpoint={`/${QUERY_KEYS.TAI_KHOAN}/`}
          searchColumns={taiKhoanSearchColumns}
          dialogTitle='Danh mục tài khoản'
          value={values.tk_tm_data?.code || ''}
          onRowSelection={handleCashAccountSelection}
          disabled={isViewMode}
          className='w-100'
        />
      </div>

      {/* Trạng thái */}
      <div className='flex flex-col sm:flex-row sm:items-center'>
        <Label className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>Trạng thái</Label>
        <FormField
          type='select'
          name='status'
          className='w-80'
          options={[
            { label: '1. Còn sử dụng', value: 1 },
            { label: '0. Không sử dụng', value: 0 }
          ]}
          defaultValue={1}
          disabled={isViewMode}
        />
      </div>
    </div>
  );
}

export default BasicInfo;
